import api from '@/plugins/request/index';

// 企业素材列表
export const getCompanySourceList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/shop-article/shop-company-articles`, params).then(res => res);
}
// 企业素材-删除素材
export const removeCompanySourceById = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/shop-article/shop-company-articles/${id}`).then(res => res);
}
// 企业素材-导入素材
export const importCompanySource = async (params, type = 'post') => {
  return api[type](`/gateway/v1/shop-article/shop-company-articles/import`, params).then(res => res);
}
// 企业素材-查看详情
export const getCompanySource = async (id, type = 'get') => {
  return api[type](`/gateway/v1/shop-article/shop-company-articles/${id}`).then(res => res);
}
// 企业素材-编辑
export const editCompanySource = async (id, params,type = 'put') => {
  return api[type](`/gateway/v1/shop-article/shop-company-articles/${id}`,params).then(res => res);
}
//获取可搜索新闻的平台
export const getCompanyPlatform = async (type = 'get') => {
  return api[type](`/gateway/v1/shop-article/shop-company-articles/news-search-platforms`).then(res => res);
}
//获取搜索新闻详情
export const getCompanyArticalDetail = async (params,type = 'get') => {
  return api[type](`/gateway/v1/shop-article/shop-company-articles/news-content`,params).then(res => res);
}
//获取平台最新新闻列表
export const getPlatformArtical = async (params,type = 'get') => {
  return api[type](`/gateway/v1/shop-article/shop-company-articles/latest-news-list`,params).then(res => res);
}
// 企业素材-设置热推
export const setResourceHot = async (id, type = 'put') => {
  return api[type](`/gateway/v1/shop-article/shop-company-articles/${id}/hot`).then(res => res);
}
// 企业素材-添加企业素材
export const addCompanyResource = async (params, type = 'post') => {
  return api[type](`/gateway/v1/shop-article/shop-company-article`, params).then(res => res);
}
//通过同步或者导入新增企业素材
export const CompanyResourceSync = async (params, type = 'post') => {
  return api[type](`/gateway/v1/shop-article/shop-company-article-by-sync`, params).then(res => res);
}
// 经纪人素材-列表
export const getAgentSourceList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/shop-article/shop-private-articles`, params).then(res => res);
}
// 经纪人素材-删除素材
export const removeAgentSourceById = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/shop-article/shop-private-articles/${id}`).then(res => res);
}
// 经纪人素材-查看详情
export const getAgentSource = async (id, type = 'get') => {
  return api[type](`/gateway/v1/shop-article/shop-private-articles/${id}`).then(res => res);
}
// 门店文章-列表
export const getShopArticleList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/shop-articles/for-admin`, params).then(res => res);
}
// 门店文章-删除素材
export const removeShopArticleById = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/shop-articles/${id}/for-admin`).then(res => res);
}
// 门店文章-查看详情
export const getShopArticle = async (id, type = 'get') => {
  return api[type](`/gateway/v1/shop-articles/${id}/for-admin`).then(res => res);
}
// 云门店统计报告
export const staticalShopReport = async (id, type = 'get') => {
  return api[type](`/gateway/v1/shop/report/${id}`).then(res => res);
}
// 云门店访客列表
export const staticalVisitList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/shop/visitor`, params).then(res => res);
}

// 云门店二手房列表
export const getEsfList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/merchant/shop-esf/houses`, params).then(res => res);
}
// 云门店二手房列表
export const esfForceOff = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/merchant/shop-esf/houses/${id}/force-off`, params).then(res => res);
}
// 云门店二手房详情
export const getEsfDetail = async (id, type = 'get') => {
  return api[type](`/gateway/v1/merchant/shop-esf/houses/${id}`).then(res => res);
}
// 云门店视频列表
export const getVideoList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/short-video/shop-videos`, params).then(res => res);
}
// 云门店发布视频列表
export const getVideoTypeList = async (type = 'get') => {
  return api[type](`/gateway/v1/short-video/platform-options`).then(res => res);
}
// 云门店删除视频
export const deleteVideoById = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/short-video/shop-videos/${id}`).then(res => res);
}
// 云门店企业海报列表
export const getPlacardList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/shop-share/shop-company-placards`, params).then(res => res);
}
// 云门店删除企业海报
export const deletePlacardById = async (params, type = 'delete') => {
  return api[type](`/gateway/v1/shop-share/shop-company-placards`,params).then(res => res);
}
// 云门店企业海报移到最前
export const updatePlacardLocation = async (params, type = 'put') => {
  return api[type](`/gateway/v1/shop-share/shop-company-placards/top`, params).then(res => res);
}
// 云门店企业海报新增
export const addPlacard = async (params, type = 'post') => {
  return api[type](`/gateway/v1/shop-share/shop-company-placards`, params).then(res => res);
}